import { render, staticRenderFns } from "./MyApprovals_Form.vue?vue&type=template&id=99b14100&scoped=true"
import script from "./MyApprovals_Form.vue?vue&type=script&lang=js"
export * from "./MyApprovals_Form.vue?vue&type=script&lang=js"
import style0 from "./MyApprovals_Form.vue?vue&type=style&index=0&id=99b14100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b14100",
  null
  
)

export default component.exports